"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DatePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _AdapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");

var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");

var _DatePicker = require("@mui/x-date-pickers/DatePicker");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePicker = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: ''
    });

    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var errorText = function errorText() {
        var error = _this2.state.error || ''; // default error to blank string

        var invalidDate = 'Invalid Date';

        if (error === 'minDate') {
          return _this2.props.minDateMessage || invalidDate;
        }

        if (error === 'maxDate') {
          return _this2.props.maxDateMessage || invalidDate;
        }

        if (error === 'invalidDate' || error.includes('shouldDisable')) {
          return invalidDate;
        }
      };

      return /*#__PURE__*/_react["default"].createElement(_LocalizationProvider.LocalizationProvider, {
        dateAdapter: _AdapterDayjs.AdapterDayjs
      }, /*#__PURE__*/_react["default"].createElement(_DatePicker.DatePicker, _extends({}, this.props, {
        slotProps: _objectSpread(_objectSpread({}, this.props.slotProps), {}, {
          textField: _objectSpread(_objectSpread({
            fullWidth: this.props.fullWidth,
            variant: this.props.variant
          }, this.props.textFieldProps), {}, {
            error: Boolean(this.props.error || this.state.error || this.props.helperText),
            helperText: this.props.helperText || errorText(),
            readOnly: this.props.readOnly || this.props.textFieldProps.readOnly
          })
        }),
        onError: function onError(error) {
          _this2.setState({
            error: error
          });

          _this2.props.onError && _this2.props.onError(error);
        } // below are added to always ensure that value being passed in is converted to a dayjs object
        ,
        value: this.props.value ? (0, _dayjs["default"])(this.props.value) : null,
        maxDate: this.props.maxDate ? (0, _dayjs["default"])(this.props.maxDate) : null,
        minDate: this.props.minDate ? (0, _dayjs["default"])(this.props.minDate) : null
      })));
    }
  }]);

  return DatePicker;
}(_react.Component);

exports.DatePicker = DatePicker;

_defineProperty(DatePicker, "propTypes", {
  fullWidth: _propTypes["default"].bool,
  variant: _propTypes["default"].string,
  maxDateMessage: _propTypes["default"].string,
  maxDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  minDateMessage: _propTypes["default"].string,
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  textFieldProps: _propTypes["default"].object,
  // props that will be passed directly into TextField, if more unique changes are needed
  toolbarProps: _propTypes["default"].object,
  // props that will be passed directly into calendar popup Toolbar, if more unique changes are needed
  slotProps: _propTypes["default"].object,
  // props that will be passed directly into slotProps, if more unique changes are needed for other components
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  error: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool
});

_defineProperty(DatePicker, "defaultProps", {
  textFieldProps: {},
  slotProps: {}
});

var _default = DatePicker;
exports["default"] = _default;